import axios from "axios";
import { SubscriptionPlanData } from "../../types/SubscriptionTypes";
import * as AppSettingsService from "../AppSettingsService";

const appSettings = AppSettingsService;

export const subscribePlan = async (
  requestBody: SubscriptionPlanData,
  isWandaConcierge: boolean
) => {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/common/Payments/v1/Subscription`;
    const response = await axios.post(baseUrl, requestBody, {
      headers: {
        "x-personId": !isWandaConcierge ? requestBody.personId : undefined,
      },
    });

    return response?.data?.subscriptionId;
  } catch (error) {
    throw error;
  }
};

export const cancelSubscriptionPlan = async (
  subscriptionId: number,
  reasonId: number,
  comment: string
) => {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/common/Payments/v1/Subscription/${subscriptionId}/cancel`;
    const response = await axios.put(baseUrl, {
      reasonId,comment
    });

    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getSubscriptionDetails = async (params: {
  personId: number;
  subscriptionTypeId: number;
}) => {
  try {
    const baseUrl = `${appSettings.getAppApiUrl()}/common/Payments/v1/Subscription/list`;
    const response = await axios.get(baseUrl, { params });

    return response?.data;
  } catch (error) {
    throw error;
  }
};
